import React from "react";
import {Button, Popconfirm} from "antd";
import {CancelWhiteSVG, PrintColorWhiteSVG, SaveWhiteIconSVG} from "assets";
import Icons from "assets/icons";
const CompletedKCB = (handleFunc): JSX.Element => {
  return (
    <Popconfirm
      onConfirm={handleFunc}
      title=""
      description="Chắc chắn hoàn thành phiếu khám tổng?"
      okText="Có"
      cancelText="Hủy"
      icon={null}
    >
      <Button className="custom-btn" type="primary" htmlType="submit">
        Hoàn thành KCB
      </Button>
    </Popconfirm>
  );
};
const Save = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
      disabled={disabled}
    >
      Lưu lại
    </Button>
  );
};

const SaveAndPrint = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="btn-sub"
      htmlType="submit"
      onClick={handleFunc}
      icon={<PrintColorWhiteSVG />}
      disabled={disabled}
    >
      Lưu và in
    </Button>
  );
};

const Completed = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 1, 3, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="btn-sub"
      htmlType="submit"
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
      // disabled={disabled}
    >
      Hoàn thành khám ĐDNT
    </Button>
  );
};

const NextPatient = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="btn-sub"
      htmlType="submit"
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
      disabled={disabled}
    >
      Bệnh nhân tiếp theo
    </Button>
  );
};

const Cancel = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 3, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Popconfirm
      onConfirm={handleFunc}
      title=""
      description="Xác nhận hủy khám?"
      okText="Có"
      cancelText="Hủy"
      // icon={null}
    >
      <Button
        className="custom-btn"
        type="primary"
        danger
        icon={<CancelWhiteSVG />}
        disabled={disabled}
      >
        Hủy khám
      </Button>
    </Popconfirm>
  );
};
const Pause = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 3, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      danger
      onClick={handleFunc}
      icon={<Icons.pause />}
      disabled={disabled}
    >
      Tạm dừng
    </Button>
  );
};

export {
  CompletedKCB,
  Save,
  Cancel,
  Completed,
  NextPatient,
  Pause,
  SaveAndPrint,
};
